export default __webpack_public_path__ + "static/media/checkbox.ad8aa3e5.svg";